import { useRef } from "react";
import AboutSection from "./AboutSection";
import ContactFormSection from "./ContactFormSection";
import Footer from "./Footer";
import TestimonialsSection from "./TestimonialsSection";
import TimelineSection from "./TimelineSection";
import TopNav from "./TopNav";
import WorksSection from "./WorksSection";

import "./portrait-small-layout.css";
import Notification from "./Notification";

function PortraitMediumLayout() {
  const aboutRef = useRef(null);
  const worksRef = useRef(null);
  const experienceRef = useRef(null);
  const contactRef = useRef(null);
  const mainDivRef = useRef(null);
  const preventIntersectionObserver = useRef(false);

  return (
    <div
      className="w-full h-full overflow-y-auto overflow-x-hidden"
      ref={mainDivRef}
    >
      <div className="w-full h-max flex flex-col">
        <TopNav
          className="fixed top-0"
          aboutRef={aboutRef}
          worksRef={worksRef}
          experienceRef={experienceRef}
          contactRef={contactRef}
          mainDivRef={mainDivRef}
          preventIntersectionObserver={preventIntersectionObserver}
        />
        <Notification />
        <div className="w-full h-max mt-[30px]">
          <AboutSection
            ref={aboutRef}
            preventIntersectionObserver={preventIntersectionObserver}
          />
          <WorksSection
            ref={worksRef}
            preventIntersectionObserver={preventIntersectionObserver}
          />
          <TimelineSection
            ref={experienceRef}
            preventIntersectionObserver={preventIntersectionObserver}
          />
          <TestimonialsSection
            preventIntersectionObserver={preventIntersectionObserver}
          />
          <ContactFormSection
            ref={contactRef}
            preventIntersectionObserver={preventIntersectionObserver}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default PortraitMediumLayout;
